export default "__VITE_ASSET__bC05BAEH__"